import functions from "../functions.js";

$(function () {
    /* gallery */
    const lg = {};
    window.showGallery = (index, id) =>
    {
        index = +index || 0;
        if (lg[id])
        {
            lg[id].index = index;
            lg[id].build(index);
        } else
        {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e)
    {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    // don't focus div with gallery
    $('[data-gallery-id]').on('focus', function (e)
    {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    });

    const $wpGallery = $('.wp-block-custom-gutenberg-gallery');
    const $btnGallery = $wpGallery.find('.btn-gallery');
    const wpGalleryLinks = $wpGallery.length && $wpGallery.attr('data-images') ? JSON.parse($wpGallery.attr('data-images')) : [];
    
    const wpGalleryArray = wpGalleryLinks.map((image) =>
    {
        return {
            src: image,
            thumb: image
        };
    });
    $wpGallery.on('click', 'img', e =>
    {
        e.preventDefault();

        const $target = $(e.currentTarget);

        let index = wpGalleryLinks.indexOf($target.attr('data-src'));
        if ($(e).hasClass('lg-on'))
        {
            $(e).data('lightGallery').index = index;
            $(e).data('lightGallery').build(index);
        } else
        {
            $(e).lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                autoplay: false,
                preload: 2,
                index: index,
                dynamicEl: wpGalleryArray
            }).addClass('lg-on');
        }
    });

    $btnGallery.on('click', e => {
        $wpGallery.find('img').first().trigger('click');  
    });

    const viewAllTranslation = {
        en: 'Images',
        de: 'Bilder',
        it: 'Immagini',
        hr: 'Slika'
    };

    $wpGallery.each((i, elem) =>
    {
        const $links = $(elem).find('.main-image');
        //let eq = $links.length >= 4 ? 3 : $links.length - 1;
        // .eq(eq)
        $links.append(
            `<div class="see-all-images">
                <div class="btn btn-outline-info btn-sm pointer rounded-pill bg-white">
                    <i class="las la-camera-retro text-info la-lg me-1"></i>
                    <span class="text-dark">${wpGalleryArray.length} ${viewAllTranslation[functions.getLang()]}</span>
                </div>
        </div>`
        );
    });
    /* end gallery */
});